export default `
mutation DeleteShift($shiftId: ID!, $updatedBy: ID!, $serviceProviderId: ID!) {
  deleteShift(shiftId: $shiftId, updatedBy: $updatedBy, serviceProviderId: $serviceProviderId) {
    createdAt
    updatedAt
    publishedAt
    acknowledgedAt
    updatedBy
    shiftId
    status
    createdBy
    userId
    isDeleted
    propertyId
    note
    startTime
    endTime
    serviceProviderId
    requests
    divisionId
    timezone
  }
}
`;